import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import request from '../../Helpers/API';
import Swal from 'sweetalert2';
import PlantillaScreen from '../helpers/PlantillaScreen';
import { Button, TextField, InputAdornment } from '@mui/material';
import { LoaderScreen } from '../components/LoaderScreen';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';


export const CentroMonitoreoCliente = () => {

    const history = useHistory();
    const [data, setData] = useState([]);
    const [busqueda, setBusqueda] = useState('');

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const onVerMaquinas = (jd_org_id) => {
        history.push(`/CentroMonitoreo/Maquinas/${jd_org_id}`);
    };

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });

        request
            .get(`Organizacion/Listado`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("LISTADO ORGANIZACIONES", JSON.stringify(error), "error");
            });

    }, []);

    const dataFiltrada = data.filter((org) => {
        const texto = busqueda.toLowerCase();
        return (
            org.jd_org_id?.toLowerCase().includes(texto) ||
            org.nombre?.toLowerCase().includes(texto)
        );
    });

    return (
        <PlantillaScreen
            titulo={"CENTRO DE MONITOREO - ORGANIZACIONES"}
            className_main={1}
            className={"centro-monitoreo-contenedor"}
        >
            <LoaderScreen loader={loader} />

            <div className='cm-contenido'>

                <div className='cm-buscador'>
                    <TextField
                        size="small"
                        placeholder="Buscar por ID o nombre..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>

                <div className="cm-tabla cm-tabla-organizaciones scroll">

                    <table className='cmt-container'>
                        <thead>
                            <tr>
                                <th>ID ORGANIZACIÓN</th>
                                <th>NOMBRE</th>
                                <th>MÁQUINAS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataFiltrada.map((org) => (
                                <tr key={org.jd_org_id}>
                                    <td>{org.jd_org_id}</td>
                                    <td>{org.nombre}</td>
                                    <td className='cm-ver-maquinas'>
                                        <Button
                                            className='button-maquinas'
                                            onClick={() => onVerMaquinas(org.jd_org_id)}
                                        >
                                            <VisibilityIcon /> Ver Máquinas
                                        </Button>
                                    </td>
                                </tr>
                            ))}

                            {dataFiltrada.length === 0 && (
                                <tr>
                                    <td colSpan={3} style={{ textAlign: 'center', padding: '20px' }}>
                                        No se encontraron organizaciones
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </div>

            </div>

        </PlantillaScreen>
    )
}